import React from "react";
import css from './InfoButton.module.scss';
import {rgba} from 'polished';
import styled from 'styled-components';

const StyledInfoRibbon = styled.div`
&& {
  background-color: ${({ theme }) => rgba(theme.color2, 0.5)};
  ${'' /* color: ${({ theme }) => theme.button.primary.text} */}
}
`;

const InfoButton = ({ icon, color, label, value }) => {
  return (
    <StyledInfoRibbon
      className={css.chapter_info}
      style={{
        // backgroundColor: `${({ theme }) => rgba(theme.color2, 1)}` ,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <span>{value}</span>
      <span className={css.info_button_name}>{label}</span>

    </StyledInfoRibbon>
  );
};

export default InfoButton;
